<script setup lang="ts">
/**
 * The brand with "powered by pixelpoint & dataCycle" (design prototype, symbol `logo-fap-quer`;
 * the website's `logo-feratelaiplus-poweredby-quer.svg`). The wordmark is `--color-accent-text`,
 * the line below follows the text colour (`currentColor`), "AI" and the stars stay feratel yellow.
 * Size it with a height class from outside.
 */
import { BRAND } from "../lib/brand.ts";
import Logo from "../assets/icons/logo-feratelaiplus-poweredby-quer.svg?component";
</script>

<template>
  <Logo role="img" :aria-label="`${BRAND}, powered by pixelpoint und dataCycle`" class="w-auto" />
</template>
